<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import { db, user } from "../firebase";
  import { conversion, lang } from "../store/store";
  import { doc, getDoc } from "firebase/firestore";
  import FileUpload from "./FileUpload.svelte";
  import { baseAPIUrl } from "../globals";
  import { authenticatedFetch } from "../appbridge";
  import { router } from "tinro";
  import { Utils } from "../utils";
  export let createTask;
  export let data;
  console.log(data);
  if (Object.entries(data.attachments).length > 0) {
    console.log(Object.entries(data.attachments));
  }
  let loading = false;
  //--------------- USER INIT ---------------
  let userinfo;
  $user.doc.subscribe((v) => {
    userinfo = v;
  });
  let secretdata;
  onMount(async () => {
    let resp = await getDoc(
      doc(db, "/stores/" + user.auth.claims.store + "/secrets/protected")
    );
    secretdata = resp.data();
  });

  let closeTask = () => {
    data.priority = selected;
    data.description = editor.getData();
    data.attachments = tempattach;
    createTask = false;
  };

  //-------------------------------------------
  let selected = data.priority;
  let priorities = [
    {
      name: $conversion[$lang].CreateTask[7][1],
      color: "#F91616", //#D2222D
      value: "Urgent",
      id: 1,
    },
    {
      name: $conversion[$lang].CreateTask[7][2],
      color: "#FFD400",
      value: "Normal",
      id: 2,
    },
    {
      name: $conversion[$lang].CreateTask[7][3],
      color: "#2C8F73", //#FFBF00
      value: "Low",
      id: 3,
    },
  ];
  let taskDetails; //to be used later to send value to firebase
  let menuCond = false; // for the dropmenu to activate
  let titleAct = false; // to activate the title black color on focus
  let detailAct = false; // to activate the detail black color on focus
  let enlighten = false; //a one time variable once user chooses a priority
  let photos = [];
  let check = {
    title: false,
    details: false,
    priority: false,
  };
  const MAX_SIZE = 1;

  function changeSelected(a) {
    selected = a;
    enlighten = true;
  }
  //-------------------- SHOW OR HIDE MENU (PRIORITY) ----------------
  $: {
    if (!!document.getElementById("menu")) {
      if (menuCond) {
        document.getElementById("menu").style.display = "flex";
      } else {
        document.getElementById("menu").style.display = "none";
      }
    }
  }
  //-------------------- CKEDITOR 5 ----------------
  let editor;
  onMount(() => {
    BalloonEditor.create(document.querySelector("#editor"), {
      placeholder: $conversion[$lang].CreateTask[5],
      removePlugins: ["WProofreader"],
      toolbar: {
        items: ["bold", "italic"],
      },
    })
      .then((newEditor) => {
        editor = newEditor;
        editor.setData(data.description);
      })
      .catch((error) => {
        console.error(error);
      });
  });
  //--------------------------------------------------
  function RemoveAttachment(params,from) {
    console.log("old photos:")
    console.log(photos)
    console.log("old tempattach:")
    console.log(tempattach)
    let i=0
  if (from=="photo"){
    photos = photos.filter(function(item) {
        return item.name !== params
})

  }

  if (from=="attach"){
      console.log("here")
      console.log(Object.entries(data.attachments));
      Object.entries(data.attachments).forEach((attach)=>{
        console.log(attach[0]);
      if (attach[1].name.indexOf(params)){
        delete data.attachments[attach[0]]
        data.attachments = data.attachments
      }
    })
  }


    Object.entries(tempattach).forEach((attach)=>{
      console.log(attach[0])
      console.log(attach[1].name)
      console.log("params:"+ params)
      if (attach[1].name.indexOf(params)){
        delete tempattach[attach[0]]
        tempattach = tempattach
      }
    })


    console.log("new photos:")
    console.log(photos)
    console.log("new tempattach:")
    console.log(tempattach)
    console.log("done")
  }
  let tempattach = data.attachments;
  function handleAttachment(event) {
    loading = true;
    photos = [...photos, ...event.target.files];
    console.log('_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-')
    console.log(photos);
    console.log('_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-')
    return;
    let f = event.target.files[0];
    if (f == undefined) {
      return;
    }
    if (f.size > 1024 * 1024 * MAX_SIZE) {
      return console.log("Big");
    }
    console.log("Acceptable");
    photos.push(URL.createObjectURL(f));
    console.log(photos);
    photos = photos;
    console.log(f.loaded);
    while (event.loaded <= f.size) {
      console.log((event.loaded / f.size) * 100);
    }
  }
  let tasks;
  let attachments = {};
  //-------------------- CALLBACK FUNCTION FROM FILEUPLOAD COMPONENT ----------------
  function callbackFunction(event) {
    let date = new Date();
    date = date.getTime();
    console.log(event.detail);
    event.detail["date"] = date;
    event.detail["from"] = "firebase";
    console.log(event.detail);
    console.log("I'm here");
    tempattach["attachment-" + date] = event.detail;
    console.log(tempattach);
    loading = false;
  }
  //---------------------------------------------------------------------------------
  //-------------------- VERIFYING AND SENDING TASK ---------------------------------
  const sendTask = async () => {
    loading = true;
    const taskDetails = editor.getData();
    if (data.title.length == 0) {
      check.title = true;
    } else {
      check.title = false;
    }

    if (taskDetails.length == 0) {
      check.details = true;
    } else {
      check.details = false;
    }

    if (selected.name == "Choose the priority") {
      check.priority = true;
    } else {
      check.priority = false;
    }
    if (!check.priority && !check.details && !check.title) {
      let date = new Date();
      date = date.getTime();
      //changing taskDetails to markdown format
      let a = taskDetails;
      a = a.replaceAll("<p>", "");
      a = a.replaceAll("</p>", "");
      a = a.replaceAll("<strong>", "**");
      a = a.replaceAll("</strong>", "**");
      a = a.replaceAll("<i>", "_");
      a = a.replaceAll("</i>", "_");
      a = a.replaceAll("<u>", "");
      a = a.replaceAll("</u>", "");
      console.log(a, "INSIDE");
      //------------------------------------
      data.attachments = tempattach;
      let taskData = {
        name: data.title,
        description: taskDetails,
        priority: { name: selected.value.toLowerCase(), id: selected.id },
        attachements: data.attachments,
      };
      let tempData = JSON.parse(JSON.stringify(taskData));
      tempData.description = a;
      console.log(userinfo.clickup);
      tempData["listid"] = secretdata.clickup.list_id;
      tempData["email"] = userinfo.account.email;
      tempData["shopDomain"] = userinfo.account.shopDomain;
      tempData["locale"] =
        userinfo.account.firstname + " " + userinfo.account.lastname;
      console.log(tempData.email);
      console.log("xd");
      console.log("Before: ", taskData);
      console.log("Before:(tempdata) ", tempData);
      /* ______________CREATING TASK IN LIST_______________ */
      let response = await authenticatedFetch(
        baseAPIUrl + "/clickup/createTask",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(tempData),
        }
      ).then((response) => {
        return response.json();
      });
      console.log(response);
      taskData["taskid"] = response.id;
      let i;
      Object.entries(data.attachments).forEach(async (element) => {
        console.log(element);
        let rep = await authenticatedFetch(
          baseAPIUrl + "/clickup/createComment",
          {
            method: "POST",
            headers: {
              "Content-Type": "text/plain",
            },
            body: JSON.stringify({
              comment_text: Utils.file.tokenToLink(
                `stores/${$user.auth.claims.store}/${element[1].name}`,
                element[1].token
              ),
              taskid: response.id,
            }),
          }
        );
      });
      console.log("after: ", taskData);
      /* ______________SENDING TO FIREBASE ALL DATA_______________ */
      await $user.create.uptask(taskData, response.id);
      data = {
          title: "",
          description: "",
          priority: { name: "Normale", id: 3, value: "Low" },
          attachments: {},
            }
      tempattach={}
      router.goto("/tasks");
      
      createTask = false;
    }
    loading = false;
  };
</script>

<div
  transition:fade={{ duration: 300 }}
  on:click={() => {
    closeTask();
  }}
  class="popup"
>
  <div on:click|stopPropagation class="popup-ctn">
    <div
      on:click={() => {
        closeTask();
      }}
      class="close-btn"
    >
      x
    </div>
    <div class="title">{$conversion[$lang].CreateTask[1]}</div>
    <div class="container">
      <div class:active={titleAct} class="task-ctn color">
        <div class="task-title">{$conversion[$lang].CreateTask[2]}</div>
        <input
          class:err={check.title}
          on:focus={() => {
            titleAct = true;
            check.title = false;
          }}
          on:blur={() => {
            titleAct = false;
          }}
          bind:value={data.title}
          class="task-input"
          type="text"
          placeholder={$conversion[$lang].CreateTask[3]}
        />
      </div>
      <div class:active={detailAct} class="task-ctn color">
        <div class="task-title">{$conversion[$lang].CreateTask[4]}</div>
        <div
          class:task-details-err={check.details}
          on:focus={() => {
            detailAct = true;
            check.details = false;
          }}
          on:blur={() => {
            detailAct = false;
          }}
          class="task-details"
          id="editor"
        />
      </div>
      <div class="task-ctn">
        <div class:active={menuCond} class="task-title color">
          {$conversion[$lang].CreateTask[6]}
        </div>
        <div
          class:err={check.priority}
          on:click={() => {
            menuCond = !menuCond;
            check.priority = false;
          }}
          class="dropdown-menu"
        >
          <div class:on={menuCond} class="arrow">></div>
          <div class="color" class:active={enlighten}>{selected.name}</div>
          <div id="menu" class="dropdown-menu-rest">
            {#each priorities as priority}
              <div
                on:click={() => {
                  changeSelected({
                    name: priority.name,
                    id: priority.id,
                    value: priority.value,
                  });
                }}
                class="priority-ctn"
              >
                <div
                  style="background-color:{priority.color}"
                  class="priority-color"
                />
                <div style="color:{priority.color}" class="priority-name">
                  {priority.name}
                </div>
              </div>
            {/each}
          </div>
        </div>
      </div>
      <div class="task-ctn">
        <div class="task-title color">
          {$conversion[$lang].CreateTask[8][1]}
        </div>
        <div class="task-attach">
          <label class="input-attach-label" for="input">
            <input
              on:change={handleAttachment}
              id="input"
              class="attach"
              type="file"
            />
            {#if Object.entries(data.attachments).length > 0 || photos.length > 0}
              <div class="attach-preview">
                {#if Object.entries(data.attachments).length > 0}
                  {#each Object.entries(data.attachments) as [id, attachment]}
                  <div class="p-wrapper">
                    <div class="upload-item">
                      <div class="u-name done">
                        {attachment.name.split("-")[1]}
                      </div>
                    </div>
                    <div on:click|stopPropagation={()=>{RemoveAttachment(attachment.name.split("-")[1],"attach")}} class="u-remove">x</div>
                  </div>
                    {/each}
                {/if}
                {#if photos.length > 0}
                  {#each photos as photo}
                  <div class="p-wrapper">
                    <FileUpload on:confirm={callbackFunction} file={photo} />
                    <div on:click|stopPropagation={()=>{RemoveAttachment(photo.name,"photo")}} class="u-remove">x</div>
                  </div>
                    {/each}
                {/if}
              </div>
            {/if}
          </label>
          <div class="task-absolute">
            <div class="task-wrap color">
              <div class="img">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="81 -6 512 512"
                  style="enable-background:new 81 -6 512 512;"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        style="fill:#7D8592"
                        d="M548.1,62.9C488.2,3,391.2,3,331.3,62.9L115.9,278.3c-46.6,46.6-46.6,122.3,0,168.9c46.6,46.6,122.3,46.5,168.9,0
                      l215.4-215.4c33.4-33.4,33.4-87.6,0-121c-33.4-33.4-87.6-33.4-121,0L195.5,294.5c-7,7-7,18.3,0,25.3c7,7,18.3,7,25.3,0L404.5,136
                      c19.4-19.4,51-19.4,70.5,0c19.4,19.4,19.4,51.1,0,70.5L259.5,421.9c-32.7,32.7-85.6,32.7-118.4,0c-15.8-15.8-24.5-36.8-24.5-59.2
                      s8.7-43.4,24.5-59.2L356.6,88.1c45.9-45.9,120.3-45.9,166.2,0c45.8,45.8,45.8,120.4,0,166.2l-95.7,95.7c-7,7-7,18.3,0,25.3
                      s18.3,7,25.3,0l95.7-95.7C608,219.7,608,122.8,548.1,62.9z"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="task-title color">
                {$conversion[$lang].CreateTask[8][2]}
              </div>
            </div>
            <div class="task-title color" style="font-weight:400">
              {$conversion[$lang].CreateTask[8][3]}
            </div>
          </div>
        </div>
      </div>
      <div class="pre-btn">
        <button
          on:click={sendTask}
          class:disabled={loading}
          disabled={loading}
          class="btn">{{ en: "Send", fr: "Envoyer" }[$lang]}</button
        >
      </div>
    </div>
  </div>
</div>

<style>
  .popup {
    background: rgba(46, 41, 78, 0.84);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    z-index: 900;
  }

  .container {
    overflow-y: auto;
    padding-right: 1rem;
  }

  .popup-ctn {
    position: relative;
    background: white;
    box-shadow: 0px 6px 58px rgba(121, 145, 173, 0.195504);
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    padding: 2rem 2.5rem 2rem 3.5rem;
    width: 35rem;
    max-height: 92%;
  }
  .close-btn {
    position: absolute;
    top: 25px;
    right: 25px;
    background-color: #f4f9fd;
    padding: 0.3rem 0.75rem;
    font-size: 1.1em;
    border-radius: 12px;
    color: black;
    cursor: pointer;
    font-weight: 700;
  }

  .title {
    font-size: 1.3em;
    color: black;
    font-weight: 600;
    margin-bottom: 2rem;
  }

  .task-ctn {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.7rem;
  }

  .color {
    color: #7d8592;
    transition: color 0.8s ease;
    font-size: 0.9em;
  }

  .task-title {
    font-size: 0.9em;
    font-weight: 700;
    margin-bottom: 0.25rem;
  }

  .task-input {
    width: 100%;
    outline: none;
    border: 1px solid #d8e0f0;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border-radius: 14px;
    padding: 0.5rem 0.75rem;
    margin-bottom: 0;
  }

  .err {
    animation: shake 0.2s ease-in-out 0s 2;
    border-color: red !important;
  }

  .task-details {
    min-height: 9.5rem !important;
    outline: none !important;
    border: 1px solid #d8e0f0 !important;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055) !important;
    border-radius: 14px !important;
    padding: 0.5rem 0.75rem !important;
    max-height: 200px !important;
    resize: none !important;
    margin-bottom: 0 !important;
  }

  .task-details-err {
    min-height: 9.5rem !important;
    outline: none !important;
    animation: shake 0.2s ease-in-out 0s 2;
    border-color: red !important;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055) !important;
    border-radius: 14px !important;
    padding: 0.5rem 0.75rem !important;
    resize: none !important;
    margin-bottom: 0 !important;
  }

  .dropdown-menu {
    position: relative;
    outline: none;
    border: 1px solid #d8e0f0;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border-radius: 14px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0.6rem 0.75rem;
    font-size: 0.9em;
    color: black;
    cursor: pointer;
  }

  .dropdown-menu-rest {
    position: absolute;
    top: 110%;
    left: 0;
    width: 100%;
    background-color: white;
    display: none;
    flex-direction: column;
    border-bottom-right-radius: 14px;
    border-bottom-left-radius: 14px;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border: 1px solid #d8e0f0;
    padding: 0.5rem 0;
    color: black;
    z-index: 500;
  }

  .priority-ctn {
    display: flex;
    align-items: center;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
  }

  .priority-color {
    padding: 0.2rem;
    border-radius: 50%;
    margin-right: 0.5rem;
  }

  .priority-name {
    font-size: 0.9em;
    color: black;
    font-weight: 600;
  }

  .task-attach {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #d8e0f0bd;
    width: 100%;
    height: 9rem;
    background: rgba(216, 224, 240, 0.74);
    border: 1px solid #d8e0f0;
    box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.222055);
    border-radius: 14px;
    cursor: pointer;
  }

  .pre-btn {
    display: flex;
    justify-content: flex-end;
  }
  .btn {
    padding: 0.5rem 2.5rem;
    background: var(--primaryColor);
    box-shadow: 0px 6px 12px rgba(44, 143, 115, 0.22);
    border-radius: 14px;
    color: white;
    transition: opacity 0.8s ease;
    cursor: pointer;
  }

  .active {
    color: black;
    transition: color 0.8s ease;
  }

  .task-wrap {
    display: flex;
    flex-direction: row;
    margin-bottom: 0.25rem;
    align-items: center;
  }

  .img {
    width: 15px;
    margin-right: 0.5rem;
  }

  .arrow {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translate(-50%, -50%) rotate(90deg);
    padding: 0.1rem 0.5rem;
    border: 1px solid #d8e0f0;
    border-radius: 50%;
  }

  .on {
    transform: translate(-50%, -50%) rotate(270deg);
  }
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
    border-radius: 10px;
  }

  .attach {
    height: 100%;
    width: 100%;
    height: 100%;
    width: 100%;
    outline: none;
    appearance: none;
    border: none;
    margin: 0;
    padding: 0;
    visibility: hidden;
  }

  .task-absolute {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .input-attach-label {
    cursor: pointer;
    height: 100%;
    width: 100%;
    z-index: 499;
    position: relative;
  }

  .attach-preview {
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #e2e8f4;
    padding: 0.5rem;
  }

  .disabled {
    opacity: 0.5;
    transition: opacity 0.8s ease;
    cursor: initial;
  }

  .attach-preview-img {
    margin: 0.2rem 0.8rem;
    height: 45%;
  }

  .above {
    height: 45%;
  }

  .done {
    color: var(--primaryColor);
    transition: color 0.8s ease;
  }

  .u-name {
    font-size: 0.875em;
    transition: color 0.8s ease;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .upload-item {
    margin: 0 0.7rem;
    display: flex;
    flex-direction: column;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .p-wrapper{
    display:flex;
    position:relative
  }

  .u-remove{
    position: absolute;
    color: #CC041E;
    right: -0px;
    top: -2px;
  }

  @keyframes shake {
    0% {
      margin-left: 0rem;
    }
    25% {
      margin-left: 0.25rem;
    }
    75% {
      margin-left: -0.25rem;
    }
    100% {
      margin-left: 0rem;
    }
  }
</style>
